import { render } from "./BlockEditor.vue?vue&type=template&id=5f5ed03f&ts=true"
import script from "./BlockEditor.vue?vue&type=script&lang=ts"
export * from "./BlockEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__